import gql from 'graphql-tag'
import clientFragment from './ClientFrangment'

export const GET_CLIENTS_ENTITY_QUERY = gql`
  query GetClientsEntity {
    clients: getClientsEntity {
      ...${clientFragment}
    }
  }
`